import { Card, styled } from '@/shared/ui/mui';
/**
 * AnimatedCard - A card component with hover animation effect
 *
 * Features:
 * - Smooth elevation transition on hover
 * - Subtle upward movement
 * - Configurable via theme
 */
export const AnimatedCard = styled(Card)(({ theme }) => ({
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[4],
  },
}));

/**
 * HoverScaleCard - A card that slightly scales on hover
 */
export const HoverScaleCard = styled(Card)(({ theme }) => ({
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: theme.shadows[3],
  },
}));

/**
 * BorderAnimatedCard - A card with a subtle border animation on hover
 */
export const BorderAnimatedCard = styled(Card)(({ theme }) => ({
  transition: 'all 0.3s ease',
  border: '1px solid transparent',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    boxShadow: theme.shadows[2],
  },
}));
